import React, { Component } from 'react';
import CustomCircleProgress from './CustomCircleProgress';

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {};
  }

  render() {

    return (
      <header id="main-toolbar"
        className="md-paper md-paper--2 md-toolbar 
                        md-background--primary md-toolbar--text-white md-toolbar--fixed">

        <h2 className="md-title md-title--toolbar">{this.props.title}</h2>

        <CustomCircleProgress
          color="white"
          visible={this.props.isBusy}
        />

        <div className="md-cell--right md-toolbar--action-right">
          {this.props.action}
          {(this.props.logOut) ? this.props.logOut() : null}
        </div>

      </header>
    )
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/Header.jsx